import experimentState, {ApplicationState} from "./state/experimentState";
import backend from "./backend";
import themeState from "./state/themeState";
import {mouseState} from "./state/mouseState";
import $ from "jquery";
import fakePointerRegister from "./state/fakePointerRegister";

function isInside(element, x, y) {
    const rect = element.getBoundingClientRect();
    return (
        x >= rect.left &&
        x <= rect.right &&
        y >= rect.top &&
        y <= rect.bottom
    );
}

function recordEvent(evt) {
    if (evt.type === "keydown" || evt.type === "keyup") {
        // console.log(evt);
        experimentState.addEvent({
            type: evt.type,
            timestamp: evt.timeStamp,
            keyCode: evt.keyCode,
            key: evt.key,
            target: `#${evt.target.id} - ${evt.target.toString()}`
        })
        if (evt.type === "keydown" && evt.key !== "Enter") {
            backend.actionRefreshTyping(true)
        }
        if (evt.type === "keydown" && evt.key === "F1") {
            themeState.toggleDisplayMouseGravity()
        }
    } else if (evt.type === "mousedown" || evt.type === "mousemove" || evt.type === "mouseup") {

        // console.log(evt);

        mouseState.setMouse(evt.pageX, evt.pageY)

        // let transform = mouseState.mouse_transforms[mouseState.mouse_transforms.length - 1]
        // let [x_fake, y_fake] = transform.mouseSpeedFn(evt.pageX, evt.pageY);
        // console.log("True:", [evt.pageX, evt.pageY], "false:", [x_fake, y_fake])
        let ele = document.elementFromPoint(mouseState.mouse_x - window.scrollX, mouseState.mouse_y - window.scrollY)
        let expEvent = {
            type: evt.type,
            timestamp: evt.timeStamp,
            x_true: evt.pageX,
            y_true: evt.pageY,
            x: mouseState.mouse_x,
            y: mouseState.mouse_y,

            target_true: `#${evt.target.id} - ${evt.target.toString()}`,
            target: (ele !== null) ? `#${ele.id} - ${ele.toString()}` : null,
        }
        // console.log(expEvent);
        experimentState.addEvent(expEvent)
        //
        // if (window.mouseCanvasComponent) {
        //     window.mouseCanvasComponent.setMouse(mouseState.fun_id, evt.pageX, evt.pageY)
        // }
        if (window.mouseJqueryComponent) {
            window.mouseJqueryComponent.updateMouse()
        }


        if (experimentState.application_state === ApplicationState.APP_CHAT) {
            // if (evt.type === 'mouseup') {
            //     mouseState.rollTransform();
            // }
            if (evt.type === "mousedown" || evt.type === "mouseup") {
                // Get current element in the viewport (subtract scroll coords from pag ecoords to get view port coords)
                let ele = document.elementFromPoint(mouseState.mouse_x - window.scrollX, mouseState.mouse_y - window.scrollY);
                if (ele) {
                    if (evt.type === "mousedown") {
                        // console.log(ele);
                        if (!$(ele).prop('disabled')) {
                            // console.log("Focusing on ele", ele);

                            $(ele).focus();
                        }
                    }
                    fakePointerRegister.get(ele.id)(evt)
                    evt.preventDefault();
                }
            }
            // If mouse is not hovering over the text area, we should disable it.
            let textarea = document.getElementById('textarea')
            if (textarea) {
                // console.log("should we disable?", {
                //     questionsStarted: experimentState.questionsStarted,
                //     questionStart: !experimentState.questionStart,
                //     pressedSend: experimentState.pressedSendOnce,
                //     combined: (experimentState.questionsStarted && !experimentState.questionStart && experimentState.pressedSendOnce),
                //     all: !isInside(textarea, mouseState.mouse_x - window.scrollX, mouseState.mouse_y - window.scrollY) || (experimentState.questionsStarted && !experimentState.questionStart && experimentState.pressedSendOnce)
                // })
                // $(textarea).prop('disabled', !isInside(textarea, mouseState.mouse_x - window.scrollX, mouseState.mouse_y - window.scrollY)  && false)
                // $(textarea).prop('disabled', !isInside(textarea, mouseState.mouse_x - window.scrollX, mouseState.mouse_y - window.scrollY) || (!experimentState.questionStart && experimentState.pressedSendOnce) )

                if (!isInside(textarea, mouseState.mouse_x - window.scrollX, mouseState.mouse_y - window.scrollY) || (experimentState.questionsStarted && !experimentState.questionStart && experimentState.pressedSendOnce)) {
                    // console.log("keeping disabled", textarea, $(textarea).prop('disabled'));
                    if (!$(textarea).prop('disabled')) {
                        $(textarea).prop('disabled', true)
                    }
                    // console.log("kept disabled", textarea, $(textarea).prop('disabled'))
                } else {
                    // console.log("dis-disabling", textarea, $(textarea).prop('disabled'))
                    if ($(textarea).prop('disabled')) {
                        $(textarea).prop('disabled', false)

                        $(textarea).focus()

                    }
                    // console.log("dis-disabling", textarea, $(textarea).prop('disabled'))
                    // $(textarea).focus();
                }
            }
        } else if (evt.type === "mousedown") {
        } else {
            evt.preventDefault();
        }
    } else if (evt.type === "msg") {
        experimentState.addEvent({
            type: evt.type,
            timestamp: performance.now(),
            question_id: evt.question_id,
            user: evt.user,
            run_id: evt.run_id,
            challenge: evt.challenge,
            challenge_params: evt.challenge_params
        })
    } else if (evt.type === 'resize') {
        // we should record the layout of the chat application here, position and size of three important UI elements.
        // The chatbox
        let chatboxEle = document.getElementById('chats')

        // The send button
        // The text area
        if (chatboxEle) {
            let ev = {
                type: evt.type,
                timestamp: performance.now(),
                chatbox_tlx: $(chatboxEle).offset().left,
                chatbox_tly: $(chatboxEle).offset().top,
                chatbox_width: $(chatboxEle).width(),
                chatbox_height: $(chatboxEle).height(),
            };
            experimentState.addEvent(ev)

            // console.log(evt, ev)
        }

    }
}

export {recordEvent}